import React from 'react'
import { Tile as TileClass, Events, type CustomEventPayload } from '../zaptic-tile'
import { createComponent, type EventName } from '@lit-labs/react'

export const Tile = createComponent(React, 'zaptic-tile', TileClass, {
    onExtraAction: Events.onExtraAction as EventName<CustomEvent<CustomEventPayload[Events.onExtraAction]>>,
    onClickEditButton: Events.onClickEditButton as EventName<CustomEvent<CustomEventPayload[Events.onClickEditButton]>>,
    onClickDeleteButton: Events.onClickDeleteButton as EventName<
        CustomEvent<CustomEventPayload[Events.onClickDeleteButton]>
    >,
})
